import {
  createNewAccount,
  getAccountSummary,
} from "@src/global_functions/postgrestApi";
import {
  useMutation,
  useQuery as useReactQuery,
  useQueryClient,
} from "@tanstack/react-query";
import { noop } from "lodash";
import { ACCOUNTS_KEY } from "../accounts/accounts";

const accounts = {
  useQuery,
  mutations: {
    usePost,
  },
} as const;

export default accounts;

export const ACCOUNT_SUMMARY_KEY = "account-summary";
function useQuery(accountId?: number) {
  return useReactQuery({
    queryKey: [ACCOUNT_SUMMARY_KEY, accountId],
    queryFn: () => {
      return getAccountSummary(accountId!);
    },
    enabled: !!accountId,
  });
}

export const useInvalidateAccountSummaryQuery = (accountId?: number) => {
  const queryClient = useQueryClient();
  return accountId
    ? () =>
        queryClient.invalidateQueries({
          queryKey: [ACCOUNT_SUMMARY_KEY, accountId],
        })
    : async () => noop;
};

function usePost() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createNewAccount,
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [ACCOUNTS_KEY],
      });
    },
  });
}
